import type {
  UpdateDashboardParams,
  UpdateDashboardResponse,
} from "$/lib/types/api/custom-dashboard.types";
import { restApiClient } from "../restApiClient";

export const updateDashboard = async (data: UpdateDashboardParams) => {
  const { id, ...rest } = data;
  return restApiClient
    .url(`/custom-dashboard/${id}`)
    .patch<UpdateDashboardResponse>({ ...rest });
};
